import { useEffect } from 'react';
import QS from 'query-string';
import { clearTokens } from '../modules/join.ducks';
import { store } from '../redux/store';

/**
 * Custom hook for handling token authentication flow
 * 
 * Priority order:
 * 1. check if code is in the URL
 * 2. if code is in the URL, then it is non-SSO login
 * 3. if code is not in the URL, then it is SSO login
 * 4. if SSO login, then check if token is in the store
 * 5. if token is not in the store, then redirect to login
 * 6. if token is in the store, then redirect to the redirect path
 * 7. if no token, then redirect to login
 * 8. if no token, then redirect to login
 * 
 * @param redirectPath - The path to redirect to after login (e.g., '/profile/account', '/profile/details')
 * @param globalState - The global state from Redux (LOGIN_URL, ACCOUNTS_URL, SSO_USER)
 * @param tokenDetails - The token details from Redux store
 * @param history - React Router history object
 */
export const useTokenAuth = (
    redirectPath: string,
    globalState: any,
    tokenDetails: any,
    history: any
) => {
    useEffect(() => {
        /**
         * if there is code in the URL, then it is non-SSO login
         */
        if(QS.parse(window.location.search).code) {
            const ssoData = globalState?.SSO_USER;
            const isSsoUser = ssoData?.enabled;
            
            if(isSsoUser) {
                localStorage.removeItem('ssoUser');
                localStorage.removeItem('ssoecardId');
                store.dispatch(clearTokens());
            }
            
            history.push(`/seamless-login?code=${QS.parse(window.location.search).code}&redirectURL=${redirectPath || '/profile/account'}`);
        }
        /**
         * if no token, then go to eachperson login
         */
        else if (tokenDetails && !tokenDetails.access_token) {
            window.location.href = `${globalState?.LOGIN_URL}${globalState?.ACCOUNTS_URL}/account`;
        }
    }, [redirectPath, globalState, tokenDetails, history]);
};

